/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import {
  Header,
  HeaderParagraph,
  CardComponent,
  Platforms,
  Footer,
  OurClient,
  Backgroundwrapper,
  ProductDescription,
  MobileFooter,
  BodyWrapper,
  Input,
  Icon
} from '../components'
import { Element } from 'react-scroll'
import { Container, BigCircle, Font51, Font20 } from '../components/StyledComponents'
import VideoLoader from '../static/video-screenhost.jpg'
import { Helmet } from 'react-helmet'
import videoUrl from '../static/experientialmarketing.mp4'

const MobileClientLogo = styled.li`
  @media (max-width: 768px) {
    display: ${props => (props.MobileLogo === true ? 'none!important' : 'block')};
  }
`
const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: 33.333%;
      margin: 0px auto;
      padding: 10px;
    }
    @media (max-width: 520px) {
      & > div {
        width: 50%;
        margin: 0px auto;
      }
  }
`
const CoreTeamWrapper = styled.div`
  padding: 80px 0px 80px 0px;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`
const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 0%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const TopImageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  background-image: url(${VideoLoader});
  background-repeat: no-repeat;
  background-size: cover;
  height: 700px;
  overflow: hidden;

  // max-width: 2560px;
  margin: 0 auto;

  & > div:first-child {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
    overflow: hidden;
    z-index: 0;
    position: relative;
    height: calc(82vh - 50px);
    // width: calc(100vw - 20px);
    width: 100%;

    & > video {
      object-fit: cover;
      width: 100%;
      min-height: 100%;
      height: auto;
      min-width: 100%;
      width: auto;
      height: auto;
      z-index: 1;
      background-size: cover;
      display: inline-block;
      vertical-align: baseline;
      object-fit: contain;
      position: relative;
      top: -150px;
    }
  }
  @media (max-width: 1450px) {
    height: 500px;
    & > div:first-child {
      & > video {
        object-fit: cover;
        width: 100%;
        min-height: 100%;
        height: auto;
        position: relative;
        top: 0px;
      }
    }
  }
  & > div:last-child {
    margin: 0;
    padding: 0px;
    height: 100%;
    @media (min-width: 240px) and (max-width: 599px) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    & > h1 {
      font-size: 28px;
      font-weight: 500;
    }
    & > p {
      font-size: 16px;
      font-weight: 300;
      line-height: 1.38;
      letter-spacing: 0.1px;
      color: #ffffff;
      padding: 10px 0 40px 0;
    }
    & > form {
      flex-direction: column;
      & > div > div {
        top: 14%;
      }
      & input {
        width: 100%;
        margin-bottom: 10px;
      }
      & button {
        width: 100%;
      }
    }
  }
  @media (max-width: 640px) {
    & > div:last-child {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}

class ExperientialMarketing extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  MobileLogoButton = e => {
    this.setState({ MobileLogoText: this.state.MobileLogo ? 'Less' : 'View More' })
    this.setState({ MobileLogo: !e })
  }

  render() {
    const { selected } = this.state
    console.log(selected)
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Top Experiential Marketing Agencies | Transparent Led Display | 8om</title>
          <meta
            name="description"
            content="One of the top experiential marketing agencies with services like Projection Mapping, Transparent LED Displays etc. to connect the consumers and the brand."
          />
          <meta
            name="keywords"
            content="experiential marketing agency, projection mapping, led video wall, transparent led display, 3d projector"
          />
        </Helmet>
        <Header />
        <ContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Experiential Marketing'}
              paragraph={
                '8OM endeavors to construct a significant connection between the consumers and the brand through our unique engagement techniques.'
              }
            />
          </TopWrapper>
          <TopImageWrapper>
            <div>
              <video playsInline loop autoPlay muted>
                <source src={videoUrl} type="video/mp4" />
              </video>
            </div>
          </TopImageWrapper>

          <Container padding={'80px 80px 50px 80px'} background="transparent">
            <Font51>Services</Font51>
            <Font20>
              When planning a campaign, we utilise a variety of strategies to create impactful experiences.
            </Font20>
            <ProductCards>
              <ProductDescription
                icon={'serviceicon2/group40.png'}
                title="AR/VR"
                width="20"
                description="Digitally immersive tech that brings your ideas to life."
              />
              <ProductDescription
                icon={'serviceicon2/group41.png'}
                title="Projection Mapping"
                width="20"
                description="Edge blending tech to convert spaces into an interactive display."
              />
              <ProductDescription
                icon={'serviceicon2/group42.png'}
                title="LCD/LED Video Wall"
                width="20"
                description="Seamless video walls with touch display & unparalleled performance."
              />
              <ProductDescription
                icon={'serviceicon2/group43.png'}
                title="Multi-Touch Solution"
                width="20"
                description="Customizable displays with quick & intuitive interfaces."
              />
              <ProductDescription
                icon={'serviceicon2/group44.png'}
                title="Digital Signage"
                width="20"
                description="A network of multimedia displays for ads, merchandising etc."
              />
              <ProductDescription
                icon={'serviceicon2/group45.png'}
                title="Transparent OLED"
                width="20"
                description="OLED screens for engaging & interactive content displays."
              />
              <ProductDescription
                icon={'serviceicon2/group46.png'}
                title="Transparent LED"
                width="20"
                description="Cost effective & versatile LED displays with vivid definition."
              />
              <ProductDescription
                icon={'serviceicon2/group52.png'}
                title="Holograms"
                width="20"
                description="Impactful information delivered through attractive 3D holograms. "
              />
              <ProductDescription
                icon={'serviceicon2/group47.png'}
                title="Robotics"
                width="20"
                description="Turnkey solutions that combine machine learning with robotics."
              />
              <ProductDescription
                icon={'serviceicon2/group48.png'}
                title="Sound & Lights"
                width="20"
                description="Custom equipment setup for both permanent and temporary basis."
              />
              <ProductDescription
                icon={'serviceicon2/group49.png'}
                title="Kinetic Lights"
                width="20"
                description="A perfect blend of lighting & movement to illuminate any event."
              />
              <ProductDescription
                icon={'serviceicon2/group50.png'}
                title="Sliding Screen"
                width="20"
                description="Create a digitally enhanced experience for those who attend events."
              />
              <ProductDescription
                icon={'serviceicon2/group51.png'}
                title="Event Management"
                width="20"
                description="From ideas to operations, we help create brand experiences."
              />
            </ProductCards>
          </Container>

          <Container background="#fff">
            <CoreTeamWrapper>
              <HeaderParagraph
                alignCenter
                headerColor={'#333333'}
                headerFontSize={'38px'}
                header={'Utilities'}
                paragraph={'Our services can be availed for the following events.'}
              />
              <TeamMemberWrapper>
                <div>
                  <div>
                    <img src={require('../static/utilitiesicons/exhibitions.png')} alt="Exhibitions" />
                  </div>
                  <p>Exhibitions</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/utilitiesicons/launches.png')} alt="Store Launches" />
                  </div>
                  <p>Store Launches</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/utilitiesicons/permanent.png')} alt="Permanent Installations" />
                  </div>
                  <p>Permanent Installations</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/utilitiesicons/company.png')} alt="Company Events" />
                  </div>
                  <p>Company Events</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/utilitiesicons/outdoor.png')} alt="Outdoor Events" />
                  </div>
                  <p>Outdoor Events</p>
                </div>
              </TeamMemberWrapper>
            </CoreTeamWrapper>
          </Container>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Get In Touch'}
              paragraph={'Sent us a message'}
            />

            <FlexContainer>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="contact" />
                  </span>
                  <p>
                    Phone
                    <span>
                      <a href="tel:+918076157787"> +91 8076157787</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/*  <AddressContent>
                  <span>
                    <Icon icon="location" />
                  </span>
                  <p>
                    Location
                    <span>
                      3rd Floor, Plot No. 8 Balaji Estate,
                      <br /> Guru Ravidas Marg, Kalkaji,
                      <br /> New Delhi, Delhi 110019
                    </span>
                  </p>
                </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </TopWrapper>
          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>We love our clients and we like to think they love us too.</ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <a href="https://www.eros-group.com/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/erosgroup.png')} alt="EROS Group" />
                    </a>
                  </li>
                  <li>
                    <a href=" " target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/garagecafe.png')} alt="Garage Cafe" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.sharjah.ae/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/governmentsarjah.png')} alt="Government of Sarjah" />
                    </a>
                  </li>
                  <li>
                    <a href="https://in.canon/en/consumer" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/canon.png')} alt="Canon" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.huawei.com/en/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/huawei.png')} alt="Huawei" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.saudiaramco.com/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/saudiaramco.png')} alt="Saudi Aramco" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.dubaipetroleum.ae/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/dubaipetroleum.png')} alt="Dubai Petroleum" />
                    </a>
                  </li>
                  <li>
                    <a href="s://goldsgym.in" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/golds.png')} alt="Gold’s Gym" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.ges.com/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/ges.png')} alt="GES" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.pico.com/en/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/pico.png')} alt="PICO" />
                    </a>
                  </li>
                  <li>
                    <a href="http://fractal.ae/" target="_blank" rel="noopener noreferrer">
                      <img src={require('../static/client_logo/fractal.png')} alt="Fractal Systems" />
                    </a>
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(ExperientialMarketing)



// WEBPACK FOOTER //
// ./src/pages/ExperientialMarketing.js